/* eslint-disable */
import {Observable} from "rxjs";
import {Injector} from "@angular/core";
import {DialogType} from "@pt/pt-models";

// @TODO core
import {DialogService} from "../services";
import {TranslateService} from "@ngx-translate/core";

let injector: Injector;

export interface ConfirmConfig {
  title?: string;
  message?: string;
  dialogType?: DialogType,
  size?: 'md' | 'sm' | 'lg' | 'xl';
}

export const Confirm = (config: ConfirmConfig): MethodDecorator => {
  let service: DialogService;
  let translate: TranslateService;

  // @ts-ignore
  return (() => {
    // @ts-ignore
    return (_target: Observable<any>, _key: string, descriptor: any) => {
      const originalMethod = descriptor.value;
      descriptor.value = async function (...args: any[]) {
        const title = config.title;
        const message = config.message;
        const dialogType = config.dialogType || DialogType.DELETE;
        const size = config.size || 'sm';

        if (title && message) {
          service = injector.get(DialogService);
          translate = injector.get(TranslateService);
          const dialogRef = service.runConfirmDialog({
            title: translate.stream(title),
            message: translate.stream(message),
            dialogType: dialogType,
            size: size
          });
          dialogRef.subscribe((confirm) => {
            if (confirm) {
              originalMethod.apply(this, ...args);
            }
          });
        }
      };
      return descriptor;
    };
  })();
}

export const setConfirmInjector = (i: Injector) => {
  injector = i;
};
